import emailOrderPrompt from 'emun.order/email-order-prompt'

export default ($window, $parse) => ({
    scope: false,
    link(scope, element, attr) {
        var onOrderEmailed = attr.onOrderEmailed || attr.onEmailOrderSaved || attr.onCreated;

        var $targets = (attr.emailOrderPromptClickSelector ? element.find(attr.emailOrderPromptClickSelector) : element);
        $targets.on('click', e => {
            var model = scope.$eval(attr.emailOrderPrompt || attr.ngModel || attr.order || attr.cart) || {
                orderNumber: attr.orderNumber || attr.cartId || attr.id,
                from: attr.from || attr.fromEmail || attr.replyTo,
                to: attr.to || attr.toEmail,
                message: attr.message
            };
            if (model.status == "Cart") {
                model.message = model.subject = "You have an open cart with " + model.clientName;
            }
            emailOrderPrompt({ title: attr.title, scope, attr, element, $targets, model }).then(
                (saved) => {
                    if (onOrderEmailed) {
                        $parse(onOrderEmailed)(scope, { $saved: saved })
                    }
                }, () => {
                    if (attr.onDismissed) {
                        $parse(attr.onDismissed)(scope, {})
                    }
                });
        });
    }
});